import { render, staticRenderFns } from "./graduationDel.vue?vue&type=template&id=18bfb224"
import script from "./graduationDel.vue?vue&type=script&lang=js"
export * from "./graduationDel.vue?vue&type=script&lang=js"
import style0 from "./graduationDel.vue?vue&type=style&index=0&id=18bfb224&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18bfb224')) {
      api.createRecord('18bfb224', component.options)
    } else {
      api.reload('18bfb224', component.options)
    }
    module.hot.accept("./graduationDel.vue?vue&type=template&id=18bfb224", function () {
      api.rerender('18bfb224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/personalDetail/graduationDel.vue"
export default component.exports